<template>
<div class="text-center pa-4">
        <v-icon @click="dialog = true" icon="$vuetify" size="x-small"></v-icon>
   <v-dialog
      v-model="dialog"
      width="auto"
    >
      <v-card
      >
        <v-card>
            <StreamBarcodeReader
            @decode="onDecode"
            @loaded="onLoaded"
            ></StreamBarcodeReader>
            <h4>EAN13:{{ decodedText }}</h4>
        </v-card>
        <template v-slot:actions>
          <v-btn
            class="ms-auto"
            text="Ok"
            @click="dialog = false"
          ></v-btn>
        </template>
      </v-card>
    </v-dialog>
  </div>

</template>
<script setup>
import { StreamBarcodeReader } from "vue-barcode-reader";
import axios from 'axios'
import store from "./store";
import { ref,watch } from "vue";
const decodedText = ref("");

const onLoaded = () => {
  // console.log("loaded");
};

const onDecode = (text) => {
  decodedText.value = text;
  dialog.value=false
};
const dialog=ref(false)

watch(decodedText,()=>{
    // console.log(decodedText.value);
    getArticles(decodedText.value)
})


function getArticles(article){   
      store.commit('updateWaiting')
      let url=    `https://my.edisac.com/goapi/articlesdeep?reference=${article}`
      
      let config = {
      method: 'get',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
      },
      url: url
      };
      return   axios.request(config)
      .then((response) => {
          store.commit('addArticles',response.data) 
          store.commit('updateWaiting')      
      })
      .catch((error) => {
      //console.log(error);
      });
      
  }


</script>